import { Injectable } from '@angular/core';
import { ShuttleTypes } from './shuttle-types';

@Injectable({
  providedIn: 'root'
})
export class ShuttleInformationService {

  private shuttleInfos = [
    { code: ShuttleTypes.Unknown, name: 'car.shuttleInformation.types.unknown' },
    { code: ShuttleTypes.InTerminal, name: 'car.shuttleInformation.types.inTerminal' },
    { code: ShuttleTypes.CarRentalShuttleOffAirport, name: 'car.shuttleInformation.types.carRentalShuttleOffAirport' },
    { code: ShuttleTypes.CarRentalShuttleInTerminal, name: 'car.shuttleInformation.types.carRentalShuttleInTerminal' },
    { code: ShuttleTypes.CarRentalShuttleOnAirport, name: 'car.shuttleInformation.types.carRentalShuttleOnAirport' },
    { code: ShuttleTypes.AirportShuttleOnAirport, name: 'car.shuttleInformation.types.airportShuttleOnAirport' },
    { code: ShuttleTypes.CallForShuttle, name: 'car.shuttleInformation.types.callForShuttle' },
    { code: ShuttleTypes.AirportShuttleThenRentalShuttle, name: 'car.shuttleInformation.types.airportShuttleThenRentalShuttle' },
    { code: ShuttleTypes.NonTerminal, name: 'car.shuttleInformation.types.nonTerminal' },
    { code: ShuttleTypes.OffAirport, name: 'car.shuttleInformation.types.offAirport' },
  ];

  constructor() { }

  public getShuttleInfo(code: number) {
    return this.shuttleInfos.find(e => e.code === code);
  }

}
